import {
    BriefSubmissionRequest,
    BriefType,
    StrategyDraftStateWrapper,
    StrategyFreelancerBriefRequest,
    StrategyFreelancerFunctionalScopesBriefRequest,
    StrategyFreelancerIndustryExpertisesBriefRequest,
    StrategyFreelancerSkillsBriefRequest,
    StrategyMissionDescriptionBriefRequest,
    StrategyWhereConditionsBriefRequest,
    FreelancerBriefRequest,
    FreelancerJobTitleBriefRequest,
    MissionDescriptionBriefRequest,
    WhenConditionsBriefRequest,
} from '@/common/api/api-raw-types';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {ResourceParams} from 'vue3-starter/src/typescript/resource/resource';
import BriefResource from './BriefResource';
import {strategyBriefResourceBuilder} from './StrategyBriefResourceBuilder';
import * as RawModel from '@/common/api/api-raw-types';
import FunctionalScope from './FunctionalScope';
import IndustryExpertise from './IndustryExpertise';

export type StrategyBriefRequest =
    | FreelancerBriefRequest
    | FreelancerJobTitleBriefRequest
    | StrategyFreelancerIndustryExpertisesBriefRequest
    | StrategyFreelancerFunctionalScopesBriefRequest
    | StrategyFreelancerSkillsBriefRequest
    | WhenConditionsBriefRequest
    | StrategyWhereConditionsBriefRequest
    | MissionDescriptionBriefRequest
    | BriefSubmissionRequest;

export default class StrategyBriefResource extends BriefResource {
    protected static async updateBrief(payload: StrategyBriefRequest, url: string): Promise<HttpServiceResponse<StrategyBriefResource>> {
        const [data, error] = await context.httpService.post<RawModel.BriefResource>(url, payload);
        if (error || !data) {
            return [null, error];
        }
        return [strategyBriefResourceBuilder.build(data), error];
    }

    draftState: StrategyDraftStateWrapper;
    type: BriefType.STRATEGY;

    constructor(params: ResourceParams) {
        super(params);
        this.draftState = params.draftState;
        this.type = params.type;
    }

    async strategySaveFreelancerProfile(payload: StrategyFreelancerBriefRequest): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyFreelancerProfileSection());
    }

    async strategySaveFunctionalScopes(payload: StrategyFreelancerFunctionalScopesBriefRequest): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyFreelancerFunctionalScopes());
    }

    async strategySaveIndustryExpertises(
        payload: StrategyFreelancerIndustryExpertisesBriefRequest,
    ): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyFreelancerIndustryExpertises());
    }

    async strategySaveFreelancerSkills(payload: StrategyFreelancerSkillsBriefRequest): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyFreelancerSkillsSection());
    }

    async strategySaveWhenConditions(payload: WhenConditionsBriefRequest): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyWhenConditionsSection());
    }

    async strategySaveWhereConditions(payload: StrategyWhereConditionsBriefRequest): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyWhereConditionsSection());
    }

    async strategySaveMissionDescription(payload: StrategyMissionDescriptionBriefRequest): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyMissionDescriptionSection());
    }

    async strategySubmitBrief(payload: BriefSubmissionRequest): Promise<HttpServiceResponse<StrategyBriefResource>> {
        return StrategyBriefResource.updateBrief(payload, this.links.strategyBriefSubmission());
    }

    async getFunctionalScopesByCategory(): Promise<HttpServiceResponse<FunctionalScope[]>> {
        const [data, error] = await context.httpService.get<RawModel.FunctionalScopeResource[]>(this.links.functionalScopesByCategory());
        if (error || !data) {
            return [null, error];
        }
        return [data, error];
    }

    async getIndustryExpertises(): Promise<HttpServiceResponse<IndustryExpertise[]>> {
        const [data, error] = await context.httpService.get<RawModel.IndustryExpertiseResource[]>(this.links.industryExpertises());
        if (error || !data) {
            return [null, error];
        }
        return [data, error];
    }

    async strategyOntologiesTranslations(): Promise<HttpServiceResponse<StrategyBriefResource>> {
        const [data, error] = await context.httpService.get<RawModel.BriefResource>(this.links.strategyOntologiesTranslations());
        if (error || !data) {
            return [null, error];
        }
        return [strategyBriefResourceBuilder.build(data), error];
    }
}
